(() => {
  const initializeSenixWinterHero = (root) => {
    if (!root || root.dataset.senixWinterInitialized === 'true') return;
    root.dataset.senixWinterInitialized = 'true';
    const wraps = [...root.querySelectorAll('[data-senix-winter-hotspot-wrap]')];
    const closeAll = (exception) => wraps.forEach((wrap) => {
      if (wrap === exception) return;
      wrap.classList.remove('senix-winter-hero__hotspot-wrap--open');
      wrap.querySelector('[data-senix-winter-hotspot]')?.setAttribute('aria-expanded', 'false');
    });
    wraps.forEach((wrap) => {
      const button = wrap.querySelector('[data-senix-winter-hotspot]');
      if (!button) return;
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        const willOpen = !wrap.classList.contains('senix-winter-hero__hotspot-wrap--open');
        closeAll(wrap);
        wrap.classList.toggle('senix-winter-hero__hotspot-wrap--open', willOpen);
        button.setAttribute('aria-expanded', String(willOpen));
      });
      wrap.addEventListener('mouseenter', () => button.setAttribute('aria-expanded', 'true'));
      wrap.addEventListener('mouseleave', () => {
        if (!wrap.classList.contains('senix-winter-hero__hotspot-wrap--open')) button.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', () => closeAll());
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeAll(); });
  };
  document.querySelectorAll('[data-senix-winter-hero]').forEach(initializeSenixWinterHero);
  document.addEventListener('shopify:section:load', (event) => initializeSenixWinterHero(event.target.querySelector('[data-senix-winter-hero]')));
})();

